import { PropsWithChildren, ChangeEvent, forwardRef } from 'react'
import { UploadFileProps } from '../../types'

export type UploadButtonProps = PropsWithChildren<{
  accept: string
  onChange: (props: UploadFileProps[]) => void
}>

const UploadButton = forwardRef<HTMLInputElement, UploadButtonProps>(
  ({ accept, onChange }, ref) => {
    const handleChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
      if (!target.files) {
        return
      }

      const props = Array.from(target.files).map((file) => ({
        file,
        objectUrl: URL.createObjectURL(file),
      }))

      onChange(props)
      target.value = ''
    }

    return (
      <input
        ref={ref}
        data-testid="input-file"
        accept={accept}
        type="file"
        onChange={handleChange}
        id="inputFile"
        className="hidden"
      />
    )
  },
)

UploadButton.displayName = 'UploadButton'

export default UploadButton
